import * as R from "ramda";

export function isCollapsedRange(range: BaseRange) {
  return range.start >= range.end;
}

export function adjustRangeValues(range: BaseRange, offset: number, cutoff: number=0) {
  return adjustRangeValuesWithFunction(range, (val) => val >= cutoff ? val + offset : val);
}

export function adjustRangeValuesAtMostToCuttoff(range: BaseRange, offset: number, cutoff: number=0) {
  return adjustRangeValuesWithFunction(range, (val) => val >= cutoff ? R.max(val + offset, cutoff) : val);
}

function adjustRangeValuesWithFunction(range: BaseRange, func: (val: number) => number) {
  return R.compose(R.over<BaseRange, number>(R.lensProp("start"), func), R.over(R.lensProp("end"), func))(range);
}

function combineRanges(ranges: Array<BaseRange>) {
  return R.sortBy((range) => range.start, ranges).reduce((acc: Array<BaseRange>, range: BaseRange) => {
    const lastRange = R.last(acc);
    if (!lastRange) {
      return [range];
    } else if (lastRange.end < range.start) {
      return acc.concat([range]);
    } else {
      return R.init(acc).concat([{
        start: lastRange.start,
        end: R.max(lastRange.end, range.end),
      }]);
    }
  }, []);
}
